import { Message } from './../models/message.models';
import { Operateur } from './../models/operateur.model';
import { Subscription } from 'rxjs';
import { PaiementObj } from './../models/paiementObj.model';
import { ConfigService } from 'ngx-envconfig';
import { AutreService } from './autre.service';
import { PaiementService } from 'app/views/paiement/paiement.service';
import { MatSnackBar } from '@angular/material';
import { AppLoaderService } from './app-loader/app-loader.service';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ResultatPaiement } from '../models/resultatPaiement.model';
import { Afpaynotif } from '../models/afpay.model';

@Injectable({
  providedIn: 'root'
})
export class MoovService {

  timeoutMoov: boolean = false;
  moovPaiementSub: Subscription;

  afpaynotif:Afpaynotif = new Afpaynotif();

  resultatPaiement: ResultatPaiement;
  VerifPaiementMtnSub: Subscription;

  public items: any[];




  compteur: any;
  interval: any;
  seconde = this.configService.get('timerMTN');
  secondeFlooz = this.configService.get('timerFlooz');

  constructor(
    private logger: NGXLogger,
    private loader: AppLoaderService,
    private snack: MatSnackBar,
    private paiementService: PaiementService,
    private autreService: AutreService,
    private configService: ConfigService

  ) { }

     /**
    * Initialisé le paiement via MOOV et obtenir le statut
    * @param paiementObj
    * @param num
    */
   effectuerPaiementMOOV(paiementObj: PaiementObj, num: string) {

    // Compteur pour arreter le checking
    // this.doCompteur (Operateur.moov, paiementObj.urlfeedback);

    this.moovPaiementSub = this.paiementService.paiementMOOV(paiementObj.user, paiementObj.pass, num, paiementObj.totalPaid, paiementObj.idpanier, paiementObj.afid,paiementObj.otp,paiementObj.operator,paiementObj.category,paiementObj.sessionid,paiementObj.offreid,paiementObj.infos)
    .subscribe(data => {


      let statuscode = data.status;
      this.logger.trace("response from moov ms " + data);
      // this.loader.close();

      // setTimeout(() => {
      //   console.log('sleep');
      //   // And any other code that should run only after 5s
      // }, 5000);


      // switch (statuscode) {
      //   case 200:
      //     case 206: {

      //     let resultat = data.body;
      //     this.logger.trace('RESULTAT', resultat);

      //       this.loader.close();
      //       this.snack.open('Paiement effectuer avec success, vous serez rediriger vers votre site d\'achat!', 'OK', { duration: 8000 });

      //       this.afpaynotif.amount = paiementObj.totalPaid;
      //       this.afpaynotif.msisdn = paiementObj.msisdn;
      //         // this.afpaynotif.responseCode = responsecode;
      //         // this.afpaynotif.responseMessage = responsemessage;
      //       this.afpaynotif.offrereference = paiementObj.offreid;

      //        // Stopper le checking
      //       clearInterval(this.interval);
      //       clearInterval(this.compteur);

      //         // if (paiementObj.isprestashop) {
      //         //   let token = this.autreService.genererToken(paiementObj.idpanier, paiementObj.apiKey, paiementObj.idcustomer);
      //         //   this.logger.trace('isPrestashop', paiementObj.isprestashop, token);

      //         // this.autreService.curlUrlRetour(paiementObj.curlParam, token, Operateur.moov, paiementObj.urlfeedback,resultat.achatbillmaptransid,paiementObj.redirectType,resultat.achatfinalstatut);
      //         // this.autreService.retourSiteMarchand(paiementObj.urlfeedback, resultat, paiementObj.idcustomer, paiementObj.idpanier,Operateur.moov);
      //       this.autreService.retourSiteMarchand(paiementObj.urlfeedback, resultat, paiementObj.idcustomer, paiementObj.idpanier,Operateur.moov,paiementObj.redirectType, this.afpaynotif);
      //     break;
      //   }
      //   default: {
      //     this.loader.close();
      //     this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 });
      //     break;
      //   }
      // }
      switch (statuscode) {
        case 200: {
          // this.loader.close();

          this.snack.open('Paiement en attente...', 'OK', { duration: 7000 });

          // let achatbillmaptransid = data.body.billMapTransactionId;
          // let achatewptransid = data.body.ewpTransactionId;
          // let afpayTransactionId = data.body.afpayTransactionId;

          let achatbillmaptransid = "";
          let achatewptransid = "";
          let afpayTransactionId = data.body.tid;

          this.logger.trace("moov tid " + afpayTransactionId);

          this.afpaynotif.afpayTransactionId = afpayTransactionId;
          this.afpaynotif.amount = paiementObj.totalPaid;
          this.afpaynotif.msisdn = paiementObj.msisdn;

          // this.afpaynotif.responseCode = responsecode;
          // this.afpaynotif.responseMessage = responsemessage;

          this.afpaynotif.offrereference = paiementObj.offreid;

          // setTimeout(() => {
          //   console.log('sleep');
          //   // And any other code that should run only after 5s
          // }, 5000);
          // timeout
          // Temps d'attente avant le premier checking (5secondes)
          this.logger.trace("starting verif======");
          this.timerVerification(achatbillmaptransid, achatewptransid, afpayTransactionId, paiementObj.urlfeedback, paiementObj.curlParam, paiementObj.apiKey, paiementObj.idcustomer, paiementObj.idpanier, paiementObj.isprestashop,paiementObj.redirectType,this.afpaynotif);

          // Compteur pour arreter le checking
          this.doCompteur (Operateur.moov, paiementObj.urlfeedback, paiementObj.curlParam, paiementObj.isprestashop, paiementObj.idcustomer, paiementObj.idpanier,afpayTransactionId,paiementObj.redirectType,this.afpaynotif);

          break;
        }
        case 204: {
          this.loader.close();
          this.snack.open('No content', 'OK', { duration: 4000 });
          break;
        }
        case 500: {
          this.loader.close();
          this.snack.open('Internal server error!', 'OK', { duration: 4000 });
          break;
        }
        default: {
          this.loader.close();
          this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 });
          break;
        }
      }
    },
    error =>  {
      let statuscode = error.status;
      this.logger.error('Erreur', error.error, error);

      switch (statuscode) {
        case 402:
          case 417: {

            // this.afpaynotif.amount = paiementObj.totalPaid;
            // this.afpaynotif.msisdn = paiementObj.msisdn;
            // this.afpaynotif.responseCode = responsecode;
            // this.afpaynotif.responseMessage = responsemessage;
            // this.afpaynotif.offrereference = paiementObj.offreid;

            let achatbillmaptransid = "";
            let achatewptransid = "";
            let afpayTransactionId = error.error.tid;

            this.logger.trace("moov tid " + afpayTransactionId);

            this.afpaynotif.afpayTransactionId = afpayTransactionId;
            this.afpaynotif.amount = paiementObj.totalPaid;
            this.afpaynotif.msisdn = paiementObj.msisdn;

            // this.afpaynotif.responseCode = responsecode;
            // this.afpaynotif.responseMessage = responsemessage;

            this.afpaynotif.offrereference = paiementObj.offreid;

        // let resultat = error.error;
        // this.logger.trace('RESULTAT', resultat);
        //   this.loader.close();
        //   if (resultat.achatfinalstatut == Message.messageTimeout) {
        //     clearInterval(this.interval);
        //     clearInterval(this.compteur);
        //     this.logger.trace('TIMEOUT');
        //     this.snack.open('Temps d\'attente depassé, vous serez rediriger sur votre site d\'achat!', 'OK', { duration: 8000 });

        //   } else if (resultat.achatfinalstatut == Message.messageNumIncorrect) {
        //     clearInterval(this.interval);
        //     clearInterval(this.compteur);
        //     this.logger.trace('NUMERO INVALIDE');
        //     this.snack.open('Numero invalide, vous serez rediriger sur votre site d\'achat!', 'OK', { duration: 8000 });

        //   } else {
        //     clearInterval(this.interval);
        //     clearInterval(this.compteur);
        //     this.logger.trace('AUTRE ERREUR');
        //     this.snack.open('Echec du paiement, vous serez rediriger sur votre site d\'achat!', 'OK', { duration: 8000 });

        //   }

        //   if (paiementObj.isprestashop) {
        //     let token = this.configService.get('mauvaisToken');
        //     this.logger.trace('isPrestashop', paiementObj.isprestashop, token);
        //     // this.autreService.curlUrlRetour(paiementObj.curlParam, token, Operateur.moov, paiementObj.urlfeedback,resultat.achatbillmaptransid,paiementObj.redirectType,resultat.achatfinalstatut);
        //     this.autreService.retourSiteMarchand(paiementObj.urlfeedback, resultat, paiementObj.idcustomer, paiementObj.idpanier,Operateur.moov,paiementObj.redirectType,this.afpaynotif);

        //     // this.autreService.retourSiteMarchand(paiementObj.urlfeedback, resultat, paiementObj.idcustomer, paiementObj.idpanier,Operateur.moov);

        //   } else {
        //     this.logger.trace('isPrestashop', paiementObj.isprestashop);
        //     this.autreService.retourSiteMarchand(paiementObj.urlfeedback, resultat, paiementObj.idcustomer, paiementObj.idpanier,Operateur.moov,paiementObj.redirectType,this.afpaynotif);
        //   }
        this.logger.trace("starting verif======");
        this.timerVerification(achatbillmaptransid, achatewptransid, afpayTransactionId, paiementObj.urlfeedback, paiementObj.curlParam, paiementObj.apiKey, paiementObj.idcustomer, paiementObj.idpanier, paiementObj.isprestashop,paiementObj.redirectType,this.afpaynotif);

          // Compteur pour arreter le checking
          this.doCompteur (Operateur.moov, paiementObj.urlfeedback, paiementObj.curlParam, paiementObj.isprestashop, paiementObj.idcustomer, paiementObj.idpanier,afpayTransactionId,paiementObj.redirectType,this.afpaynotif);


        break;
      }
        case 404: {
          this.loader.close();
          clearInterval(this.interval);
          clearInterval(this.compteur);
          this.snack.open('URL introuvable!', 'OK', { duration: 4000 });
          break;
        }
        case 500: {
          this.loader.close();
          clearInterval(this.interval);
          clearInterval(this.compteur);
          this.snack.open('Internal server error!', 'OK', { duration: 4000 });
          break;
        }
        default: {
          this.loader.close();
          clearInterval(this.interval);
          clearInterval(this.compteur);
          this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 });
          break;
        }

      }

    } );
}


  /**
   * Fonction de verification de statut (Checking regulier de 5s)
   */
  timerVerification (achatbillmaptransid, achatewptransid, afpayTransactionId, urlFeed: string, curl, apikey: string, idcustomer: String, ref: String, isPrestashop: boolean,redirectType:String,afpaynotif:Afpaynotif) {
    setTimeout(() => {

          // console.log('timeout');
          // Verifier à interval regulier (5 secondes)
        this.interval = setInterval(() => {
          // Fonction de verification
          this.verifierPaiement(achatbillmaptransid, achatewptransid, afpayTransactionId, urlFeed, curl, apikey, idcustomer, ref, isPrestashop,redirectType,afpaynotif);
        }, 5000);

    }, 5000);
  }



    /**
   * Fonction pour verifier l'etat de l'IPN de MTN
   *
   * @param achatbillmaptransid
   * @param achatewptransid
   * @param afpayTransactionId
   */
  verifierPaiement(achatbillmaptransid, achatewptransid, afpayTransactionId, urlFeed: string, curl: string, apikey: string, idcustomer, idpanier, isPrestashop: boolean,redirectType:String,afpaynotif:Afpaynotif) {

    this.logger.trace('VERIF PAIEMENT', isPrestashop, curl);
    let ispresta = isPrestashop;
    this.VerifPaiementMtnSub = this.paiementService.verifierPaiementMoov(afpayTransactionId)
    .subscribe(data => {

      // console.log('data');
      // console.log(data);
      this.logger.trace('RESULTAT CHECK OBJ', data, isPrestashop);


      let statuscode = data.status;

      switch (statuscode) {
        case 200: {
          // console.log('data');
          // console.log(data);

          let resultat = JSON.parse(data.body);
          this.logger.trace('RESULTAT CHECK', data.body);

          if (resultat.achatfinalstatut == Message.messageReussite || resultat.achatfinalstatut == "success") {
            this.loader.close();
            this.snack.open('Paiement effectuer avec success, vous serez rediriger vers votre site d\'achat!', 'OK', { duration: 8000 });
            // Stopper le checking
            clearInterval(this.interval);
            clearInterval(this.compteur);

            // if (isPrestashop) {
              // let token = this.autreService.genererToken(idpanier, apikey, idcustomer);
              // this.autreService.curlUrlRetour(curl, token, Operateur.mtn, urlFeed,afpayTransactionId,redirectType,resultat.achatfinalstatut);
              this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.moov,redirectType,afpaynotif);

              // this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.mtn);
          //  } else {
          //   this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.mtn,redirectType,afpaynotif);
          // }

        } else if(resultat.achatfinalstatut == null || resultat.achatfinalstatut == "") {
          console.log('Checking a nouveau');

        } else if(resultat.achatfinalstatut == Message.messageAttente || resultat.achatfinalstatut == "pending") {
          console.log('Checking a nouveau');
        } else if(resultat.achatfinalstatut == Message.messageEchec || resultat.achatfinalstatut == "failed") {
          clearInterval(this.interval);
          // clearInterval(this.compteur);
          //     if (isPrestashop) {
          //       let token = this.autreService.genererToken(idpanier, apikey, idcustomer);
                // this.autreService.curlUrlRetour(curl, token, Operateur.orange, urlFeed,afpayTransactionId,redirectType,resultat.achatfinalstatut);
                this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.moov,redirectType,afpaynotif);

            // } else {
            //   this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
            // }
        } else {
            console.log('Checking a nouveau');
        }

          break;
        }
        case 206: {

          // this.resultatPaiement = JSON.parse(data.body);
          let resultat = JSON.parse(data.body);
          this.logger.trace('RESULTAT CHECK', data.body);

          if (resultat.achatfinalstatut == Message.messageReussite || resultat.achatfinalstatut == "success") {
            this.loader.close();
            this.snack.open('Paiement reussi, vous serez rediriger vers votre site d\'achat!', 'OK', { duration: 8000 });
            // Stopper le checking
            clearInterval(this.interval);
            clearInterval(this.compteur);


            // if (isPrestashop) {
            //    let token = this.autreService.genererToken(idpanier, apikey, idcustomer);
              //  this.autreService.curlUrlRetour(curl, token, Operateur.mtn, urlFeed,afpayTransactionId,redirectType,resultat.achatfinalstatut);
              this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.moov,redirectType,afpaynotif);

              //  this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.mtn);
            // } else {
            //   this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.mtn,redirectType,afpaynotif);
            // }


          } else if(resultat.achatfinalstatut == Message.messageAttente || resultat.achatfinalstatut == "pending") {

          } else if(resultat.achatfinalstatut == Message.messageEchec || resultat.achatfinalstatut == "failed") {
            clearInterval(this.interval);
            clearInterval(this.compteur);
                // if (isPrestashop) {
                //   let token = this.autreService.genererToken(idpanier, apikey, idcustomer);
                  // this.autreService.curlUrlRetour(curl, token, Operateur.orange, urlFeed,afpayTransactionId,redirectType,resultat.achatfinalstatut);
                  this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.moov,redirectType,afpaynotif);

              // } else {
              //   this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.orange,redirectType,afpaynotif);
              // }
          } else {
              console.log('Checking a nouveau');
          }

          break;
        }
        case 204: {
          this.loader.close();
          this.items = [];
          this.snack.open('No content', 'OK', { duration: 4000 })
          break;
        }
        case 500: {
          this.loader.close();
          this.snack.open('Internal server error!', 'OK', { duration: 4000 })
          break;
        }
        default: {
          this.loader.close();
          this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 })
          break;
        }
      }
    },
    error => {
      let statuscode = error.status;

      this.logger.error('Erreur', error.error, error);
      this.logger.trace('Erreur 2', isPrestashop, urlFeed);




      switch (statuscode) {
        case 402: {
          this.resultatPaiement = JSON.parse(error.error);
          let resultat = JSON.parse(error.error);
          this.logger.trace('RESULTAT', resultat);

          if (resultat.achatfinalstatut == Message.messageEchec || resultat.achatfinalstatut == Message.messageCreditInsuffisant) {
            this.loader.close();
            if (resultat.achatfinalstatut == Message.messageCreditInsuffisant) {
              this.logger.trace('CREDIT INSUFFISANT');
              this.snack.open('Credit insuffisant, vous serez rediriger sur votre site d\'achat!', 'OK', { duration: 8000 });

            } else {
              this.logger.trace('AUTRE ERREUR');
              this.snack.open('Echec du paiement, vous serez rediriger sur votre site d\'achat!', 'OK', { duration: 8000 });

            }
            // console.log('Stopper interval');
            // Stopper le checking
            clearInterval(this.interval);
            clearInterval(this.compteur);

            // if (isPrestashop) {
            //   let token = this.configService.get('mauvaisToken');
            //   this.logger.trace('isPrestashop', isPrestashop, token);
              // this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.mtn);

              // this.autreService.curlUrlRetour(curl, token, Operateur.mtn, urlFeed,afpayTransactionId,redirectType,resultat.achatfinalstatut);
              this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.moov,redirectType,afpaynotif);

            // } else {
            //   this.logger.trace('isPrestashop', isPrestashop);

            //   this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.mtn,redirectType,afpaynotif);
            // }

          }
          break;
        }
        case 404: {
          this.loader.close();
          this.snack.open('URL introuvable!', 'OK', { duration: 4000 })
          break;
        }
        case 417: {
          let resultat = JSON.parse(error.error);
          this.logger.trace('RESULTAT CHECK', error.error);

          if (resultat.achatfinalstatut == Message.messageEchec) {
            this.loader.close();
            this.snack.open('Echec du paiement, vous serez rediriger sur votre site d\'achat!', 'OK', { duration: 8000 });
            // Stopper le checking
            clearInterval(this.interval);
            clearInterval(this.compteur);

            // if (isPrestashop) {
            //   let token = this.configService.get('mauvaisToken');
              // this.autreService.curlUrlRetour(curl, token, Operateur.mtn, urlFeed,afpayTransactionId,redirectType,resultat.achatfinalstatut);
              // this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.mtn);
              this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.moov,redirectType,afpaynotif);

            // } else {
            //   this.autreService.retourSiteMarchand(urlFeed, resultat, idcustomer, idpanier,Operateur.mtn,redirectType,afpaynotif);
            // }

          }
          break;
        }
        case 500: {
          this.loader.close();
          this.snack.open('Internal server error!', 'OK', { duration: 4000 })
          break;
        }
        default: {
          this.loader.close();
          this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 })
          break;
        }

      }

    } );
}



// doCompteur (operateur: string, urlFeed: string) {
//   // Timer MOOV
//   this.secondeFlooz = this.configService.get('timerFlooz');

//   this.compteur = setInterval(() => {

//     if (operateur == Operateur.mtn) {

//     this.seconde-- ;
//     if (this.seconde == 0 ) {
//       // Stopper le checking
//       clearInterval(this.compteur); // Compteur
//       clearInterval(this.interval); // Status
//       // Rediriger vers la page d'echec
//       let urlEchec = atob(urlFeed) + '&success=' + this.configService.get('mauvaisToken') + '&curlresp=' + false ;
//       window.location.href = urlEchec; // Si echec

//     }

//   } else if (operateur == Operateur.moov) {

//     this.secondeFlooz-- ;
//     if (this.secondeFlooz == 0 ) {
//       // Stopper le checking
//       clearInterval(this.compteur); // Compteur
//       // Reinitialisé le compteur

//     }

//   }

//   }, 1000);

// }

doCompteur (operateur: string, urlFeed: string, curl, isPrestashop, idcustomer, idcart, tid:String,redirectType:String,afpaynotif:Afpaynotif) {
  // Timer MOOV
  this.secondeFlooz = this.configService.get('timerFlooz');
    // Timer MTN
  this.seconde = this.configService.get('timerMTN');

  // this.secondeOrange = this.configService.get('timerOrange');

  this.compteur = setInterval(() => {
    // console.log('compteur');
    // Fonction du compteur
    // this.seconde += 1;

    if (operateur == Operateur.mtn) {

    this.seconde-- ;
    // console.log(this.seconde);
    if (this.seconde == 0 ) {
      // console.log(this.seconde);
      // Stopper le checking
      clearInterval(this.compteur); // Compteur
      clearInterval(this.interval); // Status

      this.snack.open('Temps d\'attente dépassé, vous serez rediriger sur votre site d\'achat!', 'OK', { duration: 8000 });

        this.resultatPaiement.achatfinalstatut = 'FAILED';
        this.autreService.retourSiteMarchand(urlFeed, this.resultatPaiement, idcustomer, idcart,Operateur.mtn,redirectType,afpaynotif);

    }

  } else if (operateur == Operateur.moov) {

    this.secondeFlooz-- ;
    if (this.secondeFlooz == 0 ) {
      // Stopper le checking
      clearInterval(this.compteur); // Compteur
      // Reinitialisé le compteur

      this.snack.open('Temps d\'attente dépassé, vous serez rediriger sur votre site d\'achat!', 'OK', { duration: 8000 });
        this.resultatPaiement.achatfinalstatut = 'FAILED';
        this.autreService.retourSiteMarchand(urlFeed, this.resultatPaiement, idcustomer, idcart,Operateur.moov,redirectType,afpaynotif);

    }

  }

  }, 1000);

}

}
